import axiosClient from "./axiosClient";

export const getMyStores = async () => {
    try {
        const response = await axiosClient.get("/stores", { withCredentials: true });
        // 응답 구조: { success, status, data: { stores: [...] } }
        return response.data?.data?.stores ?? [];
    } catch (error) {
        console.error("내 상점 목록 로드 중 에러 발생:", error);
        throw error;
    }
};

export const getStoreChannels = async (store_uuid) => {
    try {
        const response = await axiosClient.get(`/stores/${store_uuid}/channels`, { withCredentials: true });
        return response.data?.data?.channels ?? [];
    } catch (error) {
        console.error(`채널 목록 로드 중 에러 발생 (store: ${store_uuid}):`, error);
        throw error;
    }
};

export const getStoreDevice = async (store_uuid) => {
    try {
        const response = await axiosClient.get(`/stores/${store_uuid}/device`, { withCredentials: true });
        return response.data?.data?.device ?? null;
    } catch (error) {
        console.error(`디바이스 정보 로드 중 에러 발생 (store: ${store_uuid}):`, error);
        throw error;
    }
};

export const getStoreVirtualNumber = async (store_uuid) => {
    try {
        const response = await axiosClient.get(`/stores/${store_uuid}/virtual-number`, { withCredentials: true });
        return response.data?.data?.virtual_number ?? null;
    } catch (error) {
        console.error(`가상번호 로드 중 에러 발생 (store: ${store_uuid}):`, error);
        throw error;
    }
};